import SlideLogo from './SlideLogo'
export default SlideLogo;
